
define('ldsh!modules/page_generator/templates/navigation_tab', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a data-bypass\n  data-step="' +
((__t = ( step )) == null ? '' : __t) +
'"\n  class="js-tab-switch" href="#"><span\n  data-i18n="' +
((__t = ( translationKey )) == null ? '' : __t) +
'"></span> ' +
((__t = ( isStep || isPopup ? step : '' )) == null ? '' : __t) +
'</a>\n';

}
return __p
};});

